// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Id
 */
export interface Id {}

/**
 * Check if a given object implements the Id interface.
 */
export function instanceOfId(value: object): value is Id {
  return true;
}

export function IdFromJSON(json: any): Id {
  return IdFromJSONTyped(json, false);
}

export function IdFromJSONTyped(json: any, ignoreDiscriminator: boolean): Id {
  return json;
}

export function IdToJSON(json: any): Id {
  return IdToJSONTyped(json, false);
}

export function IdToJSONTyped(value?: Id | null, ignoreDiscriminator: boolean = false): any {
  return value;
}
